import { Component, inject, input, computed } from "@angular/core";
import { DashboardsService } from "@app/shared";
import { IBaseCard, isJobsBillingCard, isTaxprepT1Card } from "@app/views-interfaces";

@Component({
    selector: "wk-search-result",
    templateUrl: "./search-result.component.html",
    styleUrl: "./search-result.component.scss",
    standalone: false,
    host: { class: "wk-search-result fancy-scrollbar" },
})
export class SearchResultComponent {
    readonly dashboardsService = inject(DashboardsService);
    public cards = input<IBaseCard[]>([]);
    protected showLoader = input<boolean>(false);
    protected searchTerm = input<string>("");

    protected readonly cardMatchedFields = computed(() => {
        const cards = this.cards();
        const term = this.searchTerm().toLowerCase();

        if (!term) return new Map<string, string>();

        const matchMap = new Map<string, string>();

        cards.forEach((card) => {
            const matchedField = this.findMatchedField(card, term);
            if (matchedField) {
                matchMap.set(card.cardId, matchedField);
            }
        });

        return matchMap;
    });

    private findMatchedField(card: IBaseCard, searchTerm: string): string | null {
        const fieldsToCheck: Array<{ key: string; value: string | null | undefined | number }> = [
            { key: "cardId", value: card.cardId },
            { key: "firstName", value: card.contactInformation?.firstName },
            { key: "lastName", value: card.contactInformation?.lastName },
            { key: "name", value: card.name },
            { key: "email", value: card.contactInformation?.email },
            { key: "phone", value: card.contactInformation?.phone },
            { key: "cellPhone", value: card.contactInformation?.cellPhone },
        ];
        if (isJobsBillingCard(card)) {
            fieldsToCheck.push({ key: "jobId", value: card.job?.id }, { key: "clientCode", value: card.contactInformation?.clientCode });
        }
        if (isTaxprepT1Card(card)) {
            const clientCodeValue = card.clientCodes?.clientCodeId || card.clientCodes?.clientCodePIN || card.clientCodes?.clientCodeiFirm;
            fieldsToCheck.push({ key: "clientCode", value: clientCodeValue });
        }

        for (const field of fieldsToCheck) {
            if (field.value && String(field.value).toLowerCase().includes(searchTerm)) {
                return field.key;
            }
        }

        return null;
    }

    protected getMatchedFieldForCard(cardId: string): string {
        return this.cardMatchedFields().get(cardId) || "";
    }
}
